<template>
  <div class="chart">
    <Title class="chart-title" :title="$t('validatorlist.graph')" />
    <div class="chart-main-sm" v-show="size === 'xs'" />
    <div class="chart-main" v-show="size !== 'xs'" />
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getValidators } from "@/api/_common";
import Title from "@/components/MainTitle.vue";
import { mergeRecursive, generateColors } from "@/utils/graph";
import { useMq } from "vue3-mq";

const theme = {};

export default {
  name: "ValidatorsGraph",
  components: {
    Title,
  },
  props: ["validators", "pageSize"],
  data() {
    return {
      size: null,
    };
  },
  watch: {
    $route: function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
  async mounted() {
    window.addEventListener("resize", this.onResize);
    const mq = useMq().current;
    this.size = mq;
    this.renderGraphs();
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize(e) {
      if (window.innerWidth < 576 && this.size !== "xs") {
        this.size = "xs";
      } else if (window.innerWidth > 576 && this.size === "xs") {
        this.size = "nxs";
      }
    },
    async renderGraphs() {
      const parsedData = this.$props.validators.ValidatorInfos.map(
        (element) => {
          return {
            value: element.StakeAmount,
            name: element.Address,
            delegateFactor: Number(element.DelegateFactor.slice(0, -1)),
          };
        }
      );
      const totalSupply = this.$props.validators.ValidatorInfos.map((element) =>
        Number(element.StakeAmount)
      ).reduce((prev, actual) => prev + actual);

      const option = {
        title: {
          text: "Validators",
          left: "24%",
          top: "5%",
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return `${params.name} : ${params.value} (${
              (params.value / totalSupply) * 100
            }%)`;
          },
        },
        legend: {
          orient: "vertical",
          right: "3%",
          top: "25%",
        },
        series: [
          {
            name: "Validators",
            type: "pie",
            radius: "55%",
            center: ["30%", "50%"],
            data: parsedData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            color: generateColors(
              getComputedStyle(
                document.getElementsByClassName("chart")[0]
              ).getPropertyValue("color"),
              this.$props.pageSize
            ),
            label: {
              formatter: function (params) {
                return `${params.name.substr(0, 8)}...${params.name.substr(
                  34,
                  8
                )}`;
              },
            },
          },
        ],
      };
      const optionSm = {
        title: {
          show: false,
        },
        tooltip: {
          position: ["52%", "28%"],
          trigger: "item",
          formatter: function (params) {
            return `${params.name.substr(0, 4)}...${params.name.substr(
              38,
              4
            )} : ${((params.value / totalSupply) * 100).toFixed(4)}%`;
          },
        },
        legend: {
          orient: "vertical",
          top: "42%",
          left: "2%",
        },
        series: [
          {
            name: "Validators xs",
            type: "pie",
            radius: "40%",
            center: ["30%", "20%"],
            data: parsedData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            color: generateColors(
              getComputedStyle(
                document.getElementsByClassName("chart")[0]
              ).getPropertyValue("color"),
              this.$props.pageSize
            ),
            label: {
              show: false,
            },
          },
        ],
      };

      const merged = mergeRecursive(theme, option);
      const chart = echarts.init(
        document.getElementsByClassName("chart-main")[0],
        null,
        { renderer: "svg" }
      );
      chart.setOption(merged);
      const mergedSm = mergeRecursive(theme, optionSm);
      const chartSm = echarts.init(
        document.getElementsByClassName("chart-main-sm")[0],
        null,
        { renderer: "svg" }
      );
      chartSm.setOption(mergedSm);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/chart.scss";
div {
  max-width: 100%;
}
:deep(svg) {
  width: 100%;
  height: 100%;
}
</style>
